import React from 'react';
import cn from 'classnames';

import './index.less';

const SkeletonBlock = ({ className = '' }) => {
	return <div className={cn('dc-skeleton__block', className)} />;
};

/**
 * RestaurantCardSkeleton (Explore redesign)
 *
 * Matches Figma node 1395:29347.
 */
const RestaurantCardSkeleton = ({ className = '' }) => {
	return (
		<div className={cn('dc-skeleton-card', className)}>
			<div className="dc-skeleton-card__media" />
			<div className="dc-skeleton-card__content">
				<SkeletonBlock className="dc-skeleton-card__title" />
				<SkeletonBlock className="dc-skeleton-card__line" />
				<div className="dc-skeleton-card__row">
					<SkeletonBlock className="dc-skeleton-card__line dc-skeleton-card__line--w180" />
					<SkeletonBlock className="dc-skeleton-card__line dc-skeleton-card__line--w48" />
				</div>
				<SkeletonBlock className="dc-skeleton-card__line dc-skeleton-card__line--w180" />
				<SkeletonBlock className="dc-skeleton-card__line dc-skeleton-card__line--w180" />
			</div>
		</div>
	);
};

export default RestaurantCardSkeleton;
export { RestaurantCardSkeleton, SkeletonBlock };
